import { Card, CardContent, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { $danger, $darkGray } from 'styles/colors';
import { useSelector } from 'react-redux';
import { geolocationErrorSelector } from 'slice-reducers/appSlice';

const styles = {
	loader: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		color: $darkGray
	},
	redText: {
		color: $danger,
		marginTop: 20
	},
	grayText: {
		marginTop: 20
	}
};
const GeolocationErrorMessage = ({ message = '' }) => {
	const geolocationError = useSelector(geolocationErrorSelector);
	const useStyles = makeStyles(styles);
	const classes = useStyles();
	let subTtitle = message;
	switch (geolocationError.code) {
		case 1:
			subTtitle = 'User denied geolocation.';
			break;
		case 2:
			subTtitle = 'Geolocation is currently unavailable.';
			break;
		case 3:
			subTtitle = 'Geolocation has timed out.';
			break;
		default:
			break;
	}
	return (
		<Card className={classes.loader}>
			<CardContent className={classes.loader}>
				<Typography variant='h5' className={classes.redText}>
					Click map to place marker.
				</Typography>
				<Typography variant='h6' className={classes.grayText} color='textSecondary'>
					{subTtitle}
				</Typography>
			</CardContent>
		</Card>
	);
};

export default GeolocationErrorMessage;
